/**
 * @generated SignedSource<<9e711ad73a62f9a0f8543203d7de991a>>
 * @relayHash 807f0e620b159313dc25553268599830
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 70861de93bb2fad274e766975466ed85401ffa7b0e25a315a6d6b3de43a390ee

import type { ConcreteRequest } from 'relay-runtime';
export type useSpacesDataSearchSpacesQuery$variables = {
  isLicensed: boolean;
  spaceNamePattern: string;
};
export type useSpacesDataSearchSpacesQuery$data = {
  readonly spaces: {
    readonly nodes: ReadonlyArray<{
      readonly alias: string | null | undefined;
      readonly currentUser?: {
        readonly isFavourited: boolean;
      };
      readonly icon: {
        readonly path: string;
      } | null | undefined;
      readonly id: string | null | undefined;
      readonly key: string | null | undefined;
      readonly name: string | null | undefined;
      readonly status: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type useSpacesDataSearchSpacesQuery = {
  response: useSpacesDataSearchSpacesQuery$data;
  variables: useSpacesDataSearchSpacesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isLicensed"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceNamePattern"
},
v2 = [
  {
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 30
      },
      {
        "kind": "Variable",
        "name": "spaceNamePattern",
        "variableName": "spaceNamePattern"
      },
      {
        "kind": "Literal",
        "name": "status",
        "value": "current"
      }
    ],
    "concreteType": "PaginatedSpaceList",
    "kind": "LinkedField",
    "name": "spaces",
    "plural": false,
    "selections": [
      {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "alias"
          },
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "name"
          },
          {
            "kind": "ScalarField",
            "name": "key"
          },
          {
            "kind": "ScalarField",
            "name": "status"
          },
          {
            "concreteType": "Icon",
            "kind": "LinkedField",
            "name": "icon",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "path"
              }
            ]
          },
          {
            "condition": "isLicensed",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "SpaceUserMetadata",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isFavourited"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useSpacesDataSearchSpacesQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useSpacesDataSearchSpacesQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "807f0e620b159313dc25553268599830",
    "id": "70861de93bb2fad274e766975466ed85401ffa7b0e25a315a6d6b3de43a390ee",
    "metadata": {},
    "name": "useSpacesDataSearchSpacesQuery",
    "operationKind": "query",
    "text": "query useSpacesDataSearchSpacesQuery($spaceNamePattern:String!,$isLicensed:Boolean!){spaces(first:30,status:\"current\",spaceNamePattern:$spaceNamePattern){nodes{alias,id,name,key,status,icon{path},currentUser@include(if:$isLicensed){isFavourited}}}}"
  }
};
})();

(node as any).hash = "414c959dafecb5d27ba9ddb5658cc68d";

export default node;
